import { render } from "./FeedsTabs.vue?vue&type=template&id=2a4c352f"
import script from "./FeedsTabs.vue?vue&type=script&lang=js"
export * from "./FeedsTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__